//#region ng
import {
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
//#endregion

//#region models
import { TNullable } from '../../../../_core/_misc/_models/_types';
import { IDepartamento } from '../../../_misc/_models/_interfaces/_cols';
//#endregion

//#region services
import { DepartamentosService } from '../../../_ng/_services';
//#endregion

@Component({
  selector: 'me-html-departamento-card',
  templateUrl: './departamento-card.component.html',
  styleUrls: ['./departamento-card.component.scss']
})
export class MeHtmlDepartamentoCardComponent {
  //#region Meps
  #departamento: TNullable<IDepartamento>;
  get departamento(): TNullable<IDepartamento> { return this.#departamento; }
  @Input({ required: true }) set departamento(val: TNullable<IDepartamento>) {
    this.#departamento = !!val ? this.#departamentosServ.fix(val) : null;
  }
  //#endregion

  //#region outputs
  @Output() click$ = new EventEmitter<IDepartamento>();
  //#endregion

  //#region injects
  #departamentosServ = inject(DepartamentosService);
  //#endregion
}
